import { useContext } from 'react';

import type {
  FeatureFlagsContextType,
  FlagSet,
} from '#src/contexts/featureFlags/index.ts';
import { FeatureFlagsContext } from '#src/contexts/featureFlags/index.ts';

export { useLDClient } from 'launchdarkly-react-client-sdk';

const noFlags: FeatureFlagsContextType = {
  flags: {},
  monitoredFlags: {},
  identify: undefined,
};

export const useFeatureFlags = <
  T extends FlagSet = FlagSet,
>(): FeatureFlagsContextType<T> => {
  return useContext(FeatureFlagsContext) || noFlags;
};
